const businessReportTypes = {
    GET_BUSINESS_REPORT_PENDING: "GET_BUSINESS_REPORT_PENDING",
    GET_BUSINESS_REPORT_SUCCESS: "GET_BUSINESS_REPORT_SUCCESS",
    GET_BUSINESS_REPORT_ERROR: "GET_BUSINESS_REPORT_ERROR",

    CLEAR_BUSINESS_REPORT: "CLEAR_BUSINESS_REPORT",
    CHANGE_BUSINESS_REPORT_PAGE: "CHANGE_BUSINESS_REPORT_PAGE",
}

export default businessReportTypes